import { Component, ChangeDetectionStrategy } from '@angular/core';

import { EqualFilterComponent } from '../equal/equal.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { ReactiveFormsModule } from '@angular/forms';
import { Aggregation, IOption } from '../../filters';

interface ValueParser {
  (option: Aggregation): any;
}
const getKeyAsIs: ValueParser = option => option.key;
const parseNumeric: ValueParser = option => Number.parseInt(option.key);

const valueParserMap: { [key: string]: ValueParser } = {
  id: parseNumeric,
  integer: parseNumeric,
  month: parseNumeric,
  numeric: parseNumeric,
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'cbre-multi-select',
  imports: [MultiSelectModule, ReactiveFormsModule],
  templateUrl: './multi-select.component.html',
  styleUrl: './multi-select.component.scss',
})
export class MultiSelectFilterComponent extends EqualFilterComponent {
  protected _setUpFilterOptions() {
    const filter = this.filter$();
    const aggregations = this._aggregations[filter?.key] ?? [];

    const valueParser = valueParserMap[filter.dataType] ?? getKeyAsIs;
    this.options = aggregations?.filter(a => a?.key != null).map(this._makeLabelValueTransformer(valueParser));
    this._checkValuePresence();
  }

  private readonly _makeLabelValueTransformer =
    (valueParser: ValueParser) =>
    (option: Aggregation): IOption => {
      const count = option.value == null || isNaN(Number(option.value)) ? '' : ` (${Number(option.value)})`;
      const label = `${(option.displayName ?? option.key ?? '').toUpperCase()}${count}`;
      return { label, value: valueParser(option) };
    };
}
